import { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Dropdown, Space } from 'antd';
import { Link } from 'react-router';
import { IconSvg } from 'shared/icon';
import { i18n } from 'services';
import { Info } from 'shared/ui';
import _ from 'lodash';
import { StyledLeftDropdownIconWrapper, StyledArrowDropdownButton, StyledButtonPurple } from 'components/styledComponents/button/Button.styled';
import ConfirmModal from 'shared/modal/ConfirmModal';
import { ReportColumn } from 'app/userPreferences/types';
import { ExportTypes } from 'constants/enumTypes1';

const defaultItems = [
  {
    key: ExportTypes.Summary,
    label: i18n.t('csvWithDetails'),
  },
];

export interface ExportButtonProps {
  handleExport: (params: { configColumns?: ReportColumn[]; key: number }) => void;
  items?: { key: number; label: string }[];
  configColumns?: ReportColumn[];
  name?: string;
  isGenerate?: boolean;
  disabled?: boolean;
  changeGenerateReportEndedStatus?: (value: boolean) => void;
  generateReportEndedStatus?: boolean;
}

const ExportButton = ({
  handleExport,
  configColumns,
  items = defaultItems,
  name = 'exportCsv',
  isGenerate = false,
  disabled = false,
  changeGenerateReportEndedStatus,
  generateReportEndedStatus = false,
}: ExportButtonProps) => {
  const { t } = useTranslation();

  const [visible, setVisible] = useState<boolean>(false);

  const closeModal = () => {
    setVisible(false);
  };

  const handleExportClick = useCallback((key = ExportTypes.Csv) => handleExport({ configColumns, key }), [handleExport, configColumns]);

  useEffect(() => {
    if (generateReportEndedStatus) {
      setVisible(true);
      changeGenerateReportEndedStatus?.(false);
    }
  }, [changeGenerateReportEndedStatus, generateReportEndedStatus]);

  return (
    <StyledArrowDropdownButton $isGenerate={isGenerate} $disabled={disabled}>
      <ConfirmModal
        propsWidth="34.2rem"
        visible={visible}
        changeModalState={closeModal}
        text={<Info noMarginBottom content={<Trans i18nKey="generateReportNote" components={[<Link to="/exportHistory" />]} />} />}
        hideClose
        okText="ok"
      />
      {!_.isNull(items) ? (
        <Space.Compact>
          <Dropdown menu={{ onClick: ({ key }) => handleExportClick(Number(key)), items }} disabled={disabled}>
            <Button
              type="primary"
              icon={(
                <StyledLeftDropdownIconWrapper>
                  <div>
                    <IconSvg icon="ArrowLeftIcon" width="0.43rem" height="0.71rem" color="white" />
                  </div>
                </StyledLeftDropdownIconWrapper>
              )}
            />
          </Dropdown>
          <Button type="primary" onClick={() => handleExportClick()} disabled={disabled}>
            {t(name)}
          </Button>
        </Space.Compact>
      ) : (
        <StyledButtonPurple size="large" disabled={disabled} onClick={() => handleExportClick()}>
          {t(name)}
        </StyledButtonPurple>
      )}
    </StyledArrowDropdownButton>
  );
};

export default ExportButton;
